import { useCallback, useState, useEffect } from 'react';
import { UsersRequest } from '../../../../../store/reducers/UsersSlice';
import { useUsersFilterChanges } from '../useUsersFilterChanges/useUsersFilterChanges';

interface Props {
  onCallRequest: (
    value: UsersRequest | ((prev: UsersRequest) => UsersRequest),
  ) => void;
  callRequest: UsersRequest;
}

export const useUsersHandlersFilter = ({
  onCallRequest,
  callRequest,
}: Props) => {
  const { handleClinics, handleRoles, handleIsLockout } = useUsersFilterChanges(
    { onCallRequest },
  );

  const [clinicValue, setClinicValue] = useState<string[]>(
    callRequest['Filter.ClinicIds'] || [],
  );
  const [roleValue, setRoleValue] = useState<string[]>(
    callRequest['Filter.RoleIds'] || [],
  );
  const [isLockoutValue, setIsLockoutValue] = useState<string>(
    callRequest['Filter.IsLockout'] ?? 'all',
  );

  useEffect(() => {
    setClinicValue(callRequest['Filter.ClinicIds'] || []);
  }, [callRequest['Filter.ClinicIds']]);

  useEffect(() => {
    setRoleValue(callRequest['Filter.RoleIds'] || []);
  }, [callRequest['Filter.RoleIds']]);

  useEffect(() => {
    setIsLockoutValue(callRequest['Filter.IsLockout'] ?? 'all');
  }, [callRequest['Filter.IsLockout']]);

  const handleClinicsChange = useCallback(
    (value: string[]) => {
      setClinicValue(value);
      if (Array.isArray(value) && value.length === 0) {
        handleClinics(value);
      }
    },
    [clinicValue, handleClinics],
  );

  const handleRoleChange = useCallback(
    (value: string[]) => {
      setRoleValue(value);
      if (Array.isArray(value) && value.length === 0) {
        handleRoles(value);
      }
    },
    [roleValue, handleRoles],
  );

  const handleIsLockoutChange = useCallback(
    (value: string) => {
      setIsLockoutValue(value);
      handleIsLockout(value);
    },
    [handleIsLockout],
  );

  const handleOpenClinics = useCallback(
    (open: boolean) => {
      if (!open) {
        handleClinics(clinicValue);
      }
    },
    [handleClinics, clinicValue],
  );
  const handleOpenRoles = useCallback(
    (open: boolean) => {
      if (!open) {
        handleRoles(roleValue);
      }
    },
    [handleRoles, roleValue],
  );
  const handleOpenIsLockout = useCallback(() => {}, []);

  return {
    handleClinicsChange,
    clinicValue,
    handleOpenClinics,
    handleRoleChange,
    roleValue,
    handleOpenRoles,
    handleIsLockoutChange,
    isLockoutValue,
    handleOpenIsLockout,
  };
};
